
window.themeData = themeData;

import "./../icons/symbols"
import "./general/a-strict-mode"
import "./general/a-honeypot"
import "./general/a-accessible-bundle"
import "./general/a-lib"
import "./general/a-google-map" 
import "./general/a-lazyload"
import "./a-responsive"
import "./a-decorations"
import "./a-effects"
import "./l-menu"
import "./l-header"
import "./m-intro"
import "./m-home-about"
import "./m-cloud-form"
import "./m-tenders-menu"
import "./c-paginate-category"
import "./vendor/slick.min"
import "./general/a-lightbox"

var main = new Main();
lib.run_all(main);



// WEBPACK FOOTER //
// ./assets/js/main.js